import { render, staticRenderFns } from "./GmSection.vue?vue&type=template&id=9d7a0a7c&scoped=true&"
import script from "./GmSection.vue?vue&type=script&lang=ts&"
export * from "./GmSection.vue?vue&type=script&lang=ts&"
import style0 from "./GmSection.vue?vue&type=style&index=0&id=9d7a0a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a0a7c",
  null
  
)

export default component.exports